const CommunityActionTypes = {
  SET_COMMUNITY_RID: 'SET_COMMUNITY_RID',
  SET_COMMUNITY_DIRECTORY: 'SET_COMMUNITY_DIRECTORY',
  SET_COMMUNITY_MODEL_LIST: 'SET_COMMUNITY_MODEL_LIST',
  SET_COMMUNITY_DETAILS: 'SET_COMMUNITY_DETAILS',
  SET_DROPDOWN_COMM_RID: 'SET_DROPDOWN_COMM_RID'
};

export default CommunityActionTypes;
